/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

export interface ImpactStateSignature {
  Args: {
    hasError?: boolean;
  };
  Blocks: {
    default: [];
  };
}

export default templateOnly<ImpactStateSignature>();
